import { GraphQLNonNull, GraphQLInputObjectType, GraphQLList } from 'graphql'
import { ReactionOperation, reactionOperationType } from './reaction-operation'
import {
  CustomMetadataFieldInputType,
  CustomMetadataFieldMutation
} from './custom-metadata-field'

export interface CustomMetadata {
  readonly fields: CustomMetadataFieldMutation[]
  readonly newAppAction: ReactionOperation
  readonly existingAppAction: ReactionOperation
}

export const customMetadataInputType = new GraphQLInputObjectType({
  name: 'CustomMetadataInput',
  fields: () => ({
    fields: {
      description: 'List of fields',
      type: new GraphQLList(CustomMetadataFieldInputType)
    },
    newAppAction: {
      description: 'Restrict on missing required fields to new Apps only',
      type: new GraphQLNonNull(reactionOperationType)
    },
    existingAppAction: {
      description: 'Restrict on missing required fields to existing Apps only',
      type: new GraphQLNonNull(reactionOperationType)
    }
  })
})
